import React from 'react';
import { PageSpinner } from '@/components/Spinner/PageSpinner';

export const TileLoadingState: React.FC = () => (
  <div className="flex flex-1 items-center justify-center px-4 py-8">
    <PageSpinner className="size-[20px] text-subtle-foreground" />
  </div>
);
